export default __webpack_public_path__ + "images/404.svg";